var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 19,
    viewBox: "0 0 27 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.7306 12.4069V5.13783C13.3086 6.35383 15.3036 7.5308 17.6626 8.7848C15.7166 9.8708 13.3076 11.0749 10.7306 12.4069ZM25.0906 1.52894C24.5827 0.907152 23.8709 0.485575 23.0816 0.339C20.7106 -0.113 5.92359 -0.113 3.55359 0.339C2.91026 0.45827 2.31447 0.759295 1.83658 1.20619C-0.247423 3.14619 0.406577 13.5189 0.907577 15.1989C1.05032 15.7914 1.33481 16.3406 1.73659 16.799C2.21523 17.2681 2.8233 17.5831 3.48257 17.7037C5.43457 18.1037 15.4896 18.3382 23.0396 17.7682C23.7197 17.6457 24.347 17.3207 24.8396 16.8361C26.7666 14.9091 26.6396 3.95506 25.0916 1.52406",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.16ca133ddfdc61f96c388a4219b04c23.svg";
export { ForwardRef as ReactComponent };